module.exports = __webpack_public_path__ + "static/img/contact.f4b49a73.png";